class MgcOnOrderAgreement extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.submitButton = this.closest('buy-buttons')?.querySelector('button[type="submit"]');

      if (!this.checkbox || !this.submitButton) {
        return;
      }

      this.abortController = new AbortController();
      this.checkbox.addEventListener('change', () => this.updateButton(), {
        signal: this.abortController.signal
      });

      this.updateButton();
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  updateButton() {
    const needsAgreement = !this.checkbox.checked;

    this.submitButton.disabled = needsAgreement;
    this.submitButton.setAttribute('aria-disabled', needsAgreement ? 'true' : 'false');
  }
}

if (!window.customElements.get('on-order-agreement')) {
  window.customElements.define('on-order-agreement', MgcOnOrderAgreement);
}
